import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en/translation.json';
import krTranslations from './locales/kr/translation.json';

i18n
  .use(initReactI18next) // initialize react-i18next
  .init({
    resources: {
      en: { translation: enTranslations },
      kr: { translation: krTranslations },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes the values
    },
  });

export default i18n;
